import { render, staticRenderFns } from "./TabWork.vue?vue&type=template&id=75b04ba2&"
import script from "./TabWork.vue?vue&type=script&lang=js&"
export * from "./TabWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b04ba2')) {
      api.createRecord('75b04ba2', component.options)
    } else {
      api.reload('75b04ba2', component.options)
    }
    module.hot.accept("./TabWork.vue?vue&type=template&id=75b04ba2&", function () {
      api.rerender('75b04ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabWork.vue"
export default component.exports